import EventPublisher from "../utils/EventPublisher";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import SpaceAPIClient from "../client/SpaceAPIClient";
import OrderBySearchStates from "../constants/states/OrderBySearchStates";
import {SERP_RESULTS_LIMIT} from "../constants/ConfigFromBuildEnvironment";
import Time from "../utils/Time";

class SpaceActions {

    static PRICE_LOW_TO_HIGH_ORDERS = {orderBy: 2, order: 0};
    static PRICE_HIGH_TO_LOW_ORDERS = {orderBy: 2, order: 1};
    static DEFAULT_ORDERS = {orderBy: 1, order: 0};

    constructor() {
        this.spaceApiClient = new SpaceAPIClient();
        EventPublisher.subscribe(UIInteractionEvents.GOOGLE_PLACES_AUTO_COMPLETE_SERP_CHANGE, this.handleFindSpaces);
        EventPublisher.subscribe(UIInteractionEvents.LOAD_INITIAL_SPACES, this.handleFindSpaces);
        EventPublisher.subscribe(UIInteractionEvents.FILTER_BUTTON_CLICKED, this.handleFindSpaces);
        EventPublisher.subscribe(UIInteractionEvents.MAP_SEARCH_NEW_AREA_BUTTON_CLICKED, this.handleFindSpaces);
        EventPublisher.subscribe(UIInteractionEvents.LOAD_SPACES, this.handleFindSpaces);
        EventPublisher.subscribe(UIInteractionEvents.PUBLIC_SPACE_SET_SPACE_ID, this.handleGetSpace);
        EventPublisher.subscribe(UIInteractionEvents.GET_MY_SPACES, this.handleGetMySpaces);
        EventPublisher.subscribe(UIInteractionEvents.PRIVATE_SPACE_DETAILS_SET_SPACE_ID, this.handleGetPrivateSpaceDetails);
        EventPublisher.subscribe(UIInteractionEvents.SPACE_CREATE_SAVE_SUBMITTED, this.handleCreateSpace);
        EventPublisher.subscribe(UIInteractionEvents.SPACE_EDIT_SET_SPACE_ID, this.handleGetPrivateSpace);
        EventPublisher.subscribe(UIInteractionEvents.MY_SPACES_LIST_SPACE_BUTTON_CLICKED, this.handleListSpace);
        EventPublisher.subscribe(UIInteractionEvents.MY_SPACES_UNLIST_SPACE_BUTTON_CLICKED, this.handleUnlistSpace);
        EventPublisher.subscribe(UIInteractionEvents.SPACE_EDIT_SAVE_SUBMITTED, this.handleUpdateSpace);
        EventPublisher.subscribe(UIInteractionEvents.GET_MEMBER_SPACES_RESERVATIONS, this.handleGetMemberSpacesReservations);
        EventPublisher.subscribe(UIInteractionEvents.GET_MEMBER_ADVERTISEMENTS_RESERVATIONS, this.handleGetMemberAdvertisementReservations);
        EventPublisher.subscribe(UIInteractionEvents.REJECT_SPACE_RESERVATION_BUTTON_CLICKED, this.handleRejectSpaceReservation);
        EventPublisher.subscribe(UIInteractionEvents.ACCEPT_SPACE_RESERVATION_BUTTON_CLICKED, this.handleAcceptedSpaceReservation);
        EventPublisher.subscribe(UIInteractionEvents.SPACE_BALANCE_MOUNTED, this.handleLoadBalance);
        EventPublisher.subscribe(UIInteractionEvents.SPACE_BALANCE_SELECTED_MONTH_CHANGED, this.handleLoadBalance);
    }

    handleFindSpaces = (topic, data) => {
        let orderBySettings = SpaceActions.DEFAULT_ORDERS;
        if (data.orderBy.description === OrderBySearchStates.PRICE_LOW_TO_HIGH.description) {
            orderBySettings = SpaceActions.PRICE_LOW_TO_HIGH_ORDERS;
        }
        if (data.orderBy.description === OrderBySearchStates.PRICE_HIGH_TO_LOW.description) {
            orderBySettings = SpaceActions.PRICE_HIGH_TO_LOW_ORDERS;
        }
        let minPrice = data.minPrice;
        if(minPrice === "") {
            minPrice = 0;
        }
        let maxPrice = data.maxPrice;
        if(maxPrice === "") {
            maxPrice = 5;
        }
        const limit = parseInt(SERP_RESULTS_LIMIT);
        let offset = limit * (data.activePage - 1);
        if (isNaN(offset)) {
            offset = 0;
        }
        this.spaceApiClient.findSpaces(
            data.placeId,
            minPrice,
            maxPrice,
            data.distance,
            0,
            limit,
            offset,
            orderBySettings.orderBy,
            orderBySettings.order,
            data.latitude,
            data.longitude);
    };

    handleGetSpace = (topic, data) => {
        this.spaceApiClient.getSpace(data.id);
    };

    handleGetPrivateSpace = (topic, data) => {
        this.spaceApiClient.getPrivateSpace(data.id);
    };

    handleGetPrivateSpaceDetails = (topic, data) => {
        this.spaceApiClient.getPrivateSpaceDetails(data.id);
    };

    handleGetMySpaces = (topic, data) => {
        this.spaceApiClient.getMySpaces()
    };

    handleCreateSpace = (topic, data) => {
        this.spaceApiClient.createSpace(data);
    };

    handleUpdateSpace = (topic, data) => {
        this.spaceApiClient.updateSpace(data);
    };

    handleListSpace = (topic, data) => {
        this.spaceApiClient.listSpace(data);
    };

    handleUnlistSpace = (topic, data) => {
        this.spaceApiClient.unlistSpace(data);
    };

    handleGetMemberSpacesReservations = (topic, data) => {
        this.spaceApiClient.getMemberSpacesReservations();
    };

    handleGetMemberAdvertisementReservations = (topic, data) => {
        this.spaceApiClient.getMemberAdvertisementReservations();
    };

    handleRejectSpaceReservation = (topic, data) => {
        this.spaceApiClient.rejectSpaceReservation(data);
    };

    handleAcceptedSpaceReservation = (topic, data) => {
        this.spaceApiClient.acceptSpaceReservation(data);
    };

    handleLoadBalance = (topic, data) => {
        const selectedMonthDateRange = Time.getMonthDateRange(data.selectedYear, data.selectedMonth);
        this.spaceApiClient.getSpaceBalanceForRange(
            selectedMonthDateRange[0],
            selectedMonthDateRange[1]
        );
    };


}

export default new SpaceActions();
